const useCaseOwner = (user) => {
    const ownerFullName = user
        ? [user.firstName, user.lastName].filter(Boolean).join(" ")
        : "";

    const initials = user
        ? [user.firstName?.[0], user.lastName?.[0]]
            .filter(Boolean)
            .join("")
            .toUpperCase()
        : "";

    return { ownerFullName, initials };
}

export default useCaseOwner;